import fetch from 'isomorphic-fetch'
import {browserHistory} from 'react-router'
import {pendingTask, begin, end} from 'react-redux-spinner'
import {VENUE_LIST_REQUEST, VENUE_LIST, VENUE_LIST_ERROR} from './types'

export function fetchVenuesRequest() {
  //console.warn('Venue List Request Made....');
  const data = {
    loading: true,
  }
  return {
    type: VENUE_LIST_REQUEST,
    [pendingTask]: begin,
    payload: data,
  }
}

export function fetchVenuesSuccess(venues) {
  //console.warn('OK if your store is set up correctly you should have some state now :)')
  //console.warn('Venue List Success' + JSON.stringify(venues));
  const data = {
    loading: false,
    venues,
  }
  return {
    type: VENUE_LIST,
    [pendingTask]: end,
    payload: data,
  }
}

export function fetchVenuesFail(error) {
  //console.error('Venue List Failed')
  const data = {
    loading: false,
    error,
  }
  return {
    type: VENUE_LIST_ERROR,
    [pendingTask]: end,
    payload: data,
  }
}

export default function fetchVenues() {
  return dispatch => {
    //console.warn('Dispatched Venue List Request')
    dispatch(fetchVenuesRequest())
    return fetch(`${process.env.REACT_APP_EF_API_URL}/venues/`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('token'),
      },
    })
      .then(function(res) {
        if (res.status === 401) {
          browserHistory.push('/signout')
        }
        return res.json()
      })
      .then(json => {
        //console.error('WE HAVE A RESULT: ' + JSON.stringify(json))
        dispatch(fetchVenuesSuccess(json.venues))
      })
      .catch(error => dispatch(fetchVenuesFail(error)))
  }
}



/** WEBPACK FOOTER **
 ** ./src/actions/venue_list.js
 **/